import React, { useEffect, useState } from 'react';
import { UiComponents, UnoStoreHooks, EditIcon } from "@simulanisindia/ui";
import { useSelector } from 'react-redux';
import { debounce } from '../../../utils/general';
import apiClient from '../../../apiClient';
import { GROUP_UPDATE } from '../../../apiClient/apiEndpoints';

const profileFields = [
    { key: "name", label: "Name", type: "text", editable: false },
    { key: "identifier", label: "Identifier", type: "text", editable: false },
    { key: "status", label: "Status", type: "status", editable: false },
    { key: "type", label: "type", type: "dropdown", editable: false },
];

const { SimContainer, SimRow, SimColumns, SimInputBar, SimToggleSwitch, DropdownSearch } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const CompanyInformation = ({ groupDetails, handleGetGroupDetails }) => {
    const configData = useUnoSelector((state) => state.config);
    const userData = useUnoSelector((state) => state.user);
    const configSlice = useSelector((state) => state.configSlice);
    const [groupeTypes, setGroupeTypes] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        avatar: "",
        name: "",
        identifier: "",
        type: null,
        active: true
    });
    const [loading, setLoading] = useState({
        profile: false,
        information: false
    });

    const handleInputChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    useEffect(() => {
        let typeList = configSlice.groupTypes.map((role) => {
            return { value: role.id, label: role.name };
        });
        setGroupeTypes(typeList);
    }, [configSlice]);

    useEffect(() => {
        setFormData({
            avatar: groupDetails.avatar,
            name: groupDetails.name,
            identifier: groupDetails.identifier,
            type: groupDetails.type,
            active: groupDetails.active
        })
    }, [groupDetails]);

    const handleSaveGroupDetail = async () => {
        if (loading.information) return;
        try {
            if (formData.name.trim().length === 0) return;
            setLoading(pre => ({ ...pre, information: true }));
            let bodyData = {
                name: formData.name,
                identifier: formData.identifier
            }
            await apiClient.post(`${configData.config.UNO_URL}${GROUP_UPDATE}/${groupDetails.uuid}`, bodyData);
            setIsEditing(false);
            if (handleGetGroupDetails) handleGetGroupDetails();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(pre => ({ ...pre, information: false }));
        }
    };

    const handleCancelEdit = () => {
        setFormData({
            avatar: groupDetails.avatar,
            name: groupDetails.name,
            identifier: groupDetails.identifier,
            type: groupDetails.type
        })
        setIsEditing(false);
    }

    const handleDebounceDetail = debounce(handleSaveGroupDetail, 500);


    return (
        <div className="carddata colorborder">
            <div className='profileinfo'>
                <h6 className='card-heading'>Group Information</h6>
                {/* {isEditing ?
                    <div className='display-flex'>
                        <button className='roundednormalbtn d-flex align-items-center gap-1' onClick={handleCancelEdit} >
                            Cancel
                        </button>
                        <button className='roundednormalbtn d-flex align-items-center gap-1' onClick={handleDebounceDetail} >
                            {loading.information ? "Saving" : "Save"}
                        </button>
                    </div>
                    :
                    <button className='roundednormalbtn d-flex align-items-center gap-1' onClick={() => setIsEditing(true)} >
                        Edit <EditIcon />
                    </button>
                } */}
            </div>
            <div className="userdata pt-4">
                <SimContainer fluid>
                    <SimRow>
                        {profileFields.map(({ key, label, type, editable }) => {
                            if (type === "dropdown") {
                                return (
                                    <SimColumns sm="5" >
                                        <DropdownSearch
                                            label="Group Type"
                                            error={null}
                                            selectProps={{
                                                options: groupeTypes,
                                                value: formData[key],
                                                isDisabled: true, // Disable if not editing
                                                // onChange: (e) => handleInputChange("role", e), // Update formData
                                            }}
                                        />
                                    </SimColumns>
                                )
                            }
                            if (key === "status") {
                                return (
                                    <SimColumns sm="5" >
                                        <SimToggleSwitch
                                            label="Status*"
                                            checked={formData.active}
                                            onChange={(e) => setFormData((pre) => ({ ...pre, ["active"]: !pre.active }))}
                                            toggleKeyNames="Active"
                                            ToggleKeyClass="active-inactive"
                                            disabled={!editable}
                                        />
                                    </SimColumns>
                                )
                            }
                            return (
                                <SimColumns sm="5" key={key}>
                                    <label>{label}</label>
                                    {isEditing ? (
                                        <SimInputBar
                                            type={type}
                                            value={formData[key]}
                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                            className="mt-1 mb-3"
                                        />
                                    ) : (
                                        <p className='mt-1'>{formData[key]}</p>
                                    )}
                                </SimColumns>
                            )
                        }
                        )}
                    </SimRow>
                </SimContainer>
            </div>
        </div>
    );
};

export default CompanyInformation;
